import { LinkItem, LinkItemProps } from '@atlaskit/menu';
import { inject } from 'mobx-react';
import React, { RefAttributes } from 'react';

import { openLinkInNewTab, redirect } from '../../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';
import { ANALYTICS_PRODUCT_TYPE } from '../../model/productType';
import Store from '../../store';
import UserStore from '../../store/userStore';
import { getSessionSynchronisationUrl } from '../../util/auth';

interface OwnProps {
  action: string;
  actionSubject: string;
  extraAnalyticProps?: object;
  openInNewTab?: boolean;
  synchronisationApplication?: ANALYTICS_PRODUCT_TYPE;
  synchroniseSession?: boolean;
}
interface InjectedStoreProps {
  userStore: UserStore;
}

type ComponentProps = LinkItemProps &
  AnalyticsConsumerProps &
  RefAttributes<HTMLElement> &
  OwnProps &
  InjectedStoreProps;

const TrackedLinkItem = ({
  action,
  actionSubject,
  analytics,
  extraAnalyticProps,
  openInNewTab,
  synchroniseSession,
  synchronisationApplication,
  userStore,
  ...linkProps
}: ComponentProps) => {
  const { email } = userStore;
  return (
    <LinkItem
      testId="tli__link-item"
      {...linkProps}
      onClick={e => {
        if (linkProps.onClick) {
          linkProps.onClick(e);
          return;
        }
        e.preventDefault();
        if (analytics) {
          analytics.ui(actionSubject, action, extraAnalyticProps);
        }
        if (linkProps.href) {
          const url = synchroniseSession
            ? getSessionSynchronisationUrl(linkProps.href, email, synchronisationApplication)
            : linkProps.href;
          if (openInNewTab) {
            openLinkInNewTab(url);
          } else {
            redirect(url);
          }
        }
      }}
    />
  );
};

export default inject(({ userStore }: Store) => ({ userStore }))(withAnalytics(TrackedLinkItem));
